<template>
      <div no-body class="lku-adv"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
        <b-col lg="9">
          <b-form-group style="margin-bottom:-4px !important;" label-cols=1 label="Filter">
              <b-row>
                <b-col class="pr-1" cols="3"><b-form-input v-model="tblData.maintSpkNo" @keyup.13.native="refresh()" size="sm" placeholder="Workorder(SPK) No."></b-form-input></b-col>
                <b-col class="pl-1 pr-1" cols="4"><b-form-input v-model="tblData.requestby" @keyup.13.native="refresh()" size="sm" placeholder="Request By"></b-form-input></b-col>
                <b-col class="pl-1 pr-1" cols="5"><b-form-input v-model="tblData.inspectName" @keyup.13.native="refresh()" size="sm" placeholder="Description" ></b-form-input></b-col>
              </b-row>                      
          </b-form-group>
        </b-col>
        <b-col lg="3">
          <b-form-group style="margin-bottom:-4px !important;" label-cols=3 >
              <b-row>
                <b-button class="btn btn-success mr-1" @click="refresh()" size="sm"> <i class="fa fa-search"></i> Search</b-button>
                <b-button class="btn btn-secondary mr-1" @click="clearFilter()" size="sm"> <i class="fa fa-eraser"></i>Clear</b-button>
              </b-row>
          </b-form-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblPr"
          responsive
          striped hover small 
          style="font-size:smaller;" 
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
          show-empty
        >
          <template v-slot:cell(orderdate)="data">
            {{ data.item.orderdate | moment("DD MMM YYYY") }}
          </template>
          <template v-slot:cell(empty)="data">
            <h4>{{ data.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      </div>
</template>
<style lang="scss">
  .lku-adv {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import requisition from "../../apis/maintenworko";
export default {
  data() {
    return {
      items:[],
      fields: [
          {
            key: "maintSpkNo",
            thStyle: "width:100px",
            label: "WorkOrder(SPK) #",
            sortable: true
          },
          {
            key: "orderdate",
            thStyle: "width:90px",
            label: "WorkOder Date",
            sortable: true
          },
          {
            key: "inspectName",
            label: "Description",
            sortable: true
          },
          {
            key: "asetid",
            label: "Fixed Asset#",
            thStyle: "width:120px",
            sortable: true
          },
          {
            key: "asetdesc",
            label: "Fixed Asset Name",
            sortable: true
          },
          {
            key: "ascateg",
            label: "FA Catagory",
            sortable: true
          },
          {
            key: "asmodel",
            label: "Model/Type",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 10,
        total: 0,
        sortBy: 'orderdate',
        sortDesc: false,
        status:'0'
      },
      lkuLoading:false
    };
  },
  props:['filter'],
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function() {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      // console.log('filter',this.filter);
      if(this.filter){
        for (const key in this.filter) {
          if (this.filter.hasOwnProperty(key)) {
            this.tblData[key] = this.filter[key]; 
          }
        }
      }
      // console.log('this.tblData',this.tblData)
      this.lkuLoading=true;
      const list = await requisition.list(this.tblData);          
      this.lkuLoading=false;
      return list;
    },

    selectItem(item,index) {
      this.$emit("click", item);
    },
    clearFilter() {
        this.tblData.inspectName=  '';
        this.tblData.requestno=  '';
        this.tblData.requestby=  '';
        this.refresh();
    },    
    refresh: async function() {
      this.$refs.tblPr.refresh();
    }
  }
};
</script>
